'use strict';

const BANNER_SESSION_KEY = 'dismissed-banners';

/**
 * Safe get banners from session storage as JSON object
 * @return {Object} JSON object that looks like { banners: ['banner-1', 'banner-2'] }
 */
function getDismissedBanners() {
    return JSON.parse(sessionStorage.getItem(BANNER_SESSION_KEY) || null);
}

/**
 * Get a list of banners that have not been dismissed
 * @return {HTMLElement[]} List of banner div containers
 */
function getBanners() {
    return $('.promo-header-banner-container .banner-container:not(.d-none)').toArray();
}

/**
 * Hide banner parent from the DOM when all banners dismissed
 */
function checkHideBannerParent() {
    const banners = getBanners();
    if (!banners || !banners.length) {
        $('.promo-header-banner-container').addClass('d-none');
    }
}

/**
 * Get the index in list of banners of currently active banner
 * @param {HTMLElement[]} banners - list of html banners
 * @return {number} Index value of the active banner
 */
function getActiveIndex(banners) {
    return banners.findIndex(banner => $(banner).hasClass('active'));
}

/**
 * Get the next banner element, handles index out of bounds
 * @param {HTMLElement[]} banners - list of html banners
 * @return {HTMLElement} Div container for next banner
 */
function getNextElement(banners) {
    const activeIndex = getActiveIndex(banners);
    const nextIndex = activeIndex >= banners.length - 1 ? 0 : activeIndex + 1;
    return banners[nextIndex];
}

/**
 * Toggles animation to slide next banner into view
 */
function activateNextBanner() {
    const banners = getBanners();
    const nextElement = getNextElement(banners);
    $(nextElement).addClass('active');
}

/**
 * Update session storage with new dismissed banner, and updates UI
 * @param {string} id - identifier for the banner to dismiss
 */
function dismissBanner(id) {
    let dismissed = getDismissedBanners();
    if (dismissed) {
        dismissed.banners.push(id);
    } else {
        dismissed = { banners: [id] };
    }
    sessionStorage.setItem(BANNER_SESSION_KEY, JSON.stringify(dismissed));
    activateNextBanner();
    $('#' + id).addClass('d-none');

    checkHideBannerParent();
}

/**
 * Toggles the animation to remove active banner from view
 * @param {HTMLElement[]} banners - list of html banners
 */
function hideCurrentBanner(banners) {
    const activeIndex = getActiveIndex(banners);
    const banner = banners[activeIndex];

    $(banner).addClass('hide');

    setTimeout(() => {
        $(banner).removeClass('active');
        $(banner).removeClass('hide');
    }, 500);
}

const INTERVAL_TIME = 6000;
let intervalId;

/**
 * Hides active banner and shows next banner
 * Cleans up interval when all banners dismissed
 */
function cycleBanners() {
    const banners = getBanners();
    if (banners && banners.length > 1) {
        hideCurrentBanner(banners);
        activateNextBanner();
    } else {
        clearInterval(intervalId);
    }
}

module.exports = {
    configurePromoBanner: function () {
        let $banners = $('.promo-header-banner-container .banner-container').toArray();

        const dismissedInfo = getDismissedBanners();

        if (dismissedInfo && dismissedInfo.banners) {
            $banners = $banners.filter(banner => !dismissedInfo.banners.find(id => id === $(banner).attr('id')));
        }

        $banners.forEach((banner, index) => {
            if (index === 0) {
                $(banner).addClass('active');
            } else {
                $(banner).addClass('inactive');
            }
            $(banner).removeClass('d-none');

            $(banner).find('.dismiss-button').on('click', e => {
                e.preventDefault();
                const id = $(e.currentTarget).data('button-id');
                dismissBanner(id);
            });
        });

        checkHideBannerParent();

        intervalId = setInterval(cycleBanners, INTERVAL_TIME);
    }
};
